export default function CarrierFinancialManagement() {

  return (
      <p>مدیریت مالی</p>
  );
};